module.exports = __webpack_public_path__ + "static/img/073_TO8_1700.8fd4118.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/073_TO8_1700.jpg
// module id = cXEj
// module chunks = 0